
import React from 'react'
import { Animated } from 'react-web-animation'

export default class RoomM extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 1051,
      originalHeight: 944
    }
    this.state = {
      ...this.state,
      width: parseFloat(props.width),
      height: this.state.originalHeight / (this.state.originalWidth / parseFloat(props.width)),
      ratio: this.state.originalWidth / parseFloat(props.width)
    }
  }
  render() {
    return (
      <div>
        <svg height={this.state.height} width={this.state.width} viewBox={`0 0 ${this.state.originalWidth} ${this.state.originalHeight}`}>
          <defs>
            <polygon id="path-1" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-2" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-3" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-4" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-5" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-6" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-7" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-8" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-9" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-10" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-11" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-12" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-13" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-14" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-15" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-16" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-17" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-18" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-19" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-20" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-21" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-22" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-23" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-24" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-25" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-26" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-27" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-28" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-29" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-30" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-31" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-32" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-33" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-34" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-35" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-36" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-37" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-38" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-39" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-40" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-41" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-42" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-43" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-44" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-45" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-46" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-47" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-48" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-49" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-50" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-51" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-52" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-53" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-54" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-55" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-56" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
            <polygon id="path-57" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
            <polygon id="path-58" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
            <polygon id="path-59" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
            <polygon id="path-60" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
            <polygon id="path-61" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
            <polygon id="path-62" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
            <polygon id="path-63" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
            <polygon id="path-64" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
          </defs>
          <g id="Packages/M" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <polygon id="Rectangle-8" fill="#DFDFDF" points="41.209039 196.948752 651.381485 197.121839 512.291038 395.248123 -97.881408 395.075036" transform="translate(276.750039, 296.098438) rotate(-35.000000) translate(-276.750039, -296.098438) "/>
            <polygon id="Rectangle-8" fill="#929292" points="541.039486 198.142862 1148.14134 197.927137 1009.26112 396.226508 402.440706 396.040391" transform="translate(775.291021, 297.076822) scale(-1, 1) rotate(-35.000000) translate(-775.291021, -297.076822) "/>
            <g id="Boden/8x8" transform="translate(-98.000000, 224.000000)">
              <g id="10m" transform="translate(124.679245, 305.464151)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(187.018868, 261.826415)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(248.467925, 218.188679)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(310.807547, 174.550943)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(373.147170, 130.913208)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(435.486792, 87.275472)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(496.935849, 43.637736)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
              <g id="10m" transform="translate(559.275472, 0.000000)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(62.972528, 62.972528) rotate(45.000000) translate(-62.972528, -62.972528) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="31.6684575 31.6684575 107.50083 18.4442266 94.2765994 94.2765994 18.4442266 107.50083"/>
                  <path d="M32.0533416,32.0533416 L18.9917027,106.953354 L93.8917153,93.8917153 L106.953354,18.9917027 L32.0533416,32.0533416 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(312.331019, 237.523472) rotate(45.000000) translate(-312.331019, -237.523472) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="281.026948 206.219401 356.859321 192.99517 343.63509 268.827543 267.802717 282.051774"/>
                  <path d="M281.411832,206.604285 L268.350193,281.504298 L343.250206,268.442659 L356.311845,193.542646 L281.411832,206.604285 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(187.651774, 150.248000) rotate(45.000000) translate(-187.651774, -150.248000) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="156.347703 118.943929 232.180076 105.719698 218.955845 181.552071 143.123472 194.776302"/>
                  <path d="M156.732587,119.328813 L143.670948,194.228826 L218.570961,181.167187 L231.632599,106.267174 L156.732587,119.328813 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(437.010264, 324.798944) rotate(45.000000) translate(-437.010264, -324.798944) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="405.706193 293.494873 481.538566 280.270642 468.314335 356.103014 392.481962 369.327245"/>
                  <path d="M406.091077,293.879757 L393.029439,368.779769 L467.929451,355.71813 L480.99109,280.818118 L406.091077,293.879757 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(125.312151, 106.610264) rotate(45.000000) translate(-125.312151, -106.610264) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="94.0080802 75.3061934 169.840453 62.0819624 156.616222 137.914335 80.7838492 151.138566"/>
                  <path d="M94.3929642,75.6910774 L81.3313254,150.59109 L156.231338,137.529451 L169.292977,62.6294386 L94.3929642,75.6910774 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(374.670642, 281.161208) rotate(45.000000) translate(-374.670642, -281.161208) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="343.366571 249.857137 419.198944 236.632906 405.974713 312.465279 330.14234 325.68951"/>
                  <path d="M343.751455,250.242021 L330.689816,325.142033 L405.589829,312.080395 L418.651467,237.180382 L343.751455,250.242021 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(249.991396, 193.885736) rotate(45.000000) translate(-249.991396, -193.885736) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="218.687325 162.581665 294.519698 149.357434 281.295467 225.189807 205.463094 238.414038"/>
                  <path d="M219.072209,162.966549 L206.010571,237.866562 L280.910583,224.804923 L293.972222,149.90491 L219.072209,162.966549 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(499.349887, 368.436679) rotate(45.000000) translate(-499.349887, -368.436679) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="468.045816 337.132608 543.878189 323.908377 530.653958 399.74075 454.821585 412.964981"/>
                  <path d="M468.4307,337.517493 L455.369061,412.417505 L530.269074,399.355866 L543.330713,324.455854 L468.4307,337.517493 Z" stroke="#979797" strokeWidth="0.890566038"/>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <Desk ratio={ this.state.ratio } />
        <Pretreat ratio={ this.state.ratio } />
        <Press ratio={ this.state.ratio } />
        <Gtx1 ratio={ this.state.ratio } />
        <Gtx2 ratio={ this.state.ratio } />
        <Gtx3 ratio={ this.state.ratio } />
        <Senddesk ratio={ this.state.ratio } />
        <Dryer ratio={ this.state.ratio } />
      </div>
    )
	}
}

class Gtx1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 313,
      originalHeight: 223,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 328 / this.state.ratio, left: 461 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Gtx2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 313,
      originalHeight: 223,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 414 / this.state.ratio, left: 588 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Gtx3 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 313,
      originalHeight: 223,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 502 / this.state.ratio, left: 714 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Senddesk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 251,
      originalHeight: 201,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 611 / this.state.ratio, left: 587 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/senddesk.png")} />
    )
  }
}

class Desk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 251,
      originalHeight: 178,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 502 / this.state.ratio, left: 399 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/desk.png")} />
    )
  }
}

class Press extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 190,
      originalHeight: 185,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 235 / this.state.ratio, left: 399 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/press.png")} />
    )
  }
}

class Pretreat extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 190,
      originalHeight: 176,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 198 / this.state.ratio, left: 461 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/pretreat.png")} />
    )
  }
}

class Dryer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 498,
      originalHeight: 375,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 355 / this.state.ratio, left: 25 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/dryer.png")} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/room/rooms/M.js